import { Button, Form } from "react-bootstrap";
import { ChangeEvent, useState, useEffect } from "react";
import { restoreUser } from "../api/authAPI";
import { useTranslation } from "react-i18next";
import { UserRestorePwdDto } from "../types";
import { useNavigate } from 'react-router-dom';

interface FormData {
  passwordRepeat: string;
  password: string;
}

type RestorePwdFormProps = {
    uid: string;
    language: string;
};

export const RestorePwdForm = ({ uid, language }: RestorePwdFormProps) => {

    const [formData, setFormData] = useState<FormData>({
        passwordRepeat: '',
        password: ''
  });

    const [error, setError] = useState<string>('');
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        i18n.changeLanguage(language); // Cambia a espa�ol
    }, []);

  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    };

    const isPasswordValid = (pwd: string): boolean => {
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!$%&/()="])[A-Za-z\d!$%&/()="]{6,20}$/;
        return passwordRegex.test(pwd);
    };

  const handleSubmit = async (e: React.FormEvent) => {
      e.preventDefault();
      if (!formData.password || !formData.passwordRepeat) {
          setError(t("auth:errorsRestorePwd.messageRestorePwdValidateEmptyFields"));
      return;
      }
      if (formData.password != formData.passwordRepeat) {
          setError(t("auth:errorsRestorePwd.messageRestorePwdValidateSameValue"));
          return;
      }

      if (!isPasswordValid(formData.password)) {
          setError(t("auth:errorsRestorePwd.messageRestorePwdValidateFormat"));
          return;
      }


      setError("");

      const body: UserRestorePwdDto = {
          password: formData.password,
          uid: uid,
          language: language,
      }


      try {
          await restoreUser(body);
          navigate(`/`)
      } catch (e) {
          setError('ERROR');
          console.log(e);
          return;
      }

  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
              <Form.Label>{t("auth:restorePwd.labelRestorePwd")}</Form.Label>
        <Form.Control
          type="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
        />
      </Form.Group>

      <Form.Group className="mb-4">
              <Form.Label>{t("auth:restorePwd.labelRestorePwd2")} </Form.Label>
        <Form.Control
          type="password"
          name="passwordRepeat"
          value={formData.passwordRepeat}
          onChange={handleChange}
        />
      </Form.Group>

      {error && <div className="alert alert-danger mb-3">{error}</div>}
          <p>{t("auth:restorePwd.labelRestorePwdRemember")}</p>

          <div className="d-flex justify-content-end">
        <Button variant="success" type="submit">
                  {t("common:buttons.buttonRestorePassword")}
        </Button>
      </div>
    </Form>
  );
}